<template>
  <div>
    <dl class="row px-3 px-sm-5 pt-3 mb-0">
      <dt class="no-colon d-print-none w-xs-100">Aksiyon Seçiniz</dt>
      <dd class="single d-print-none w-xs-100 pl-1 pl-sm-0">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="idea-action"
              id="cbx-submit"
              data-target="#tab-form-approve"
              value="approve"
              v-model="evaluate"
            />
            <label class="form-check-label" for="cbx-submit">Onayla</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="idea-action"
              id="cbx-return"
              data-target="#tab-form-return"
              value="return"
              v-model="evaluate"
            />
            <label class="form-check-label" for="cbx-return">Geri Gönder</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="idea-action"
              id="cbx-reject"
              data-target="#tab-form-decline"
              value="decline"
              v-model="evaluate"
            />
            <label class="form-check-label" for="cbx-reject">Reddet</label>
          </div>

          <div v-if="evaluate == 'approve'" id="tab-form-approve" style="">
            <form
              action="/Admin/Update/c5dd0e00-a1d9-eb11-bacb-000d3addce7f?updateType=1&amp;status=Distributer"
              id="update-form"
              method="post"
            >
              <div class="form-group icon-folder-alt icon-down">
                <select
                  class="form-control"
                  id="searchFilterValueCurrent"
                  name="ValueCurrent"
                  title="Tümü"
                  placeholder="Tümü"
                  v-model="valueCurrentId"
                >
                  <option value="">İlgili Alan Seçiniz</option>
                  <optgroup
                    v-for="item in currenValuelist"
                    :key="item.Name"
                    :label="item.Name"
                  >
                    <option
                      v-for="company in item.ValueCurrentDTOs"
                      :key="company.Id"
                      :value="company.Id"
                    >
                      {{ company.Name }}
                    </option>
                  </optgroup>
                </select>
              </div>
              <div
                id="drpValueCurrentError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('valueCurrentId')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş geçilemez!
              </div>

              <div class="row pl-5 mb-2 modal-bar">Fikir Değerlendirme</div>

              <div>
                <dl>
                  <div
                    v-for="category in doinPointStructureList"
                    :key="category.Id"
                    :value="category.Id"
                  >
                    <label style="width: 200px"
                      ><strong>{{ category.Name }}</strong>
                      <i
                        v-if="category.Description"
                        class="icon-question category-info"
                        :title="category.Description"
                      ></i
                    ></label>
                    <div
                      style="width: 100%"
                      class="form-check form-check-inline"
                      v-for="subCategory in category.SubCategories"
                      :key="subCategory.Id"
                      :value="subCategory.Id"
                    >
                      <div
                        style="width: 300px"
                        v-if="category.SubCategories.length === 2"
                        class="form-check form-check-inline"
                      >
                        <input
                          type="radio"
                          :id="'subcategory_' + subCategory.Id"
                          data-target="#tab-form-approve"
                          :value="'subcategory_' + subCategory.Id"
                          class="form-check-input"
                          :name="'category_' + category.Id"
                          :checked="
                            checkSelectedSubCategory(
                              category.Id,
                              subCategory.Id
                            )
                          "
                          @change="
                            selectedCategories(category.Id, subCategory.Id)
                          "
                        />
                        <label
                          :for="'subcategory_' + subCategory.Id"
                          class="form-check-label"
                          >{{ subCategory.Name }}</label
                        >
                      </div>

                      <div
                        style="width: 300px"
                        v-if="category.SubCategories.length > 2"
                        class="form-check form-check-inline"
                      >
                        <input
                          type="checkbox"
                          :id="'subcategory_' + subCategory.Id"
                          data-target="#tab-form-approve"
                          :value="subCategory.Id"
                          class="form-check-input"
                          :name="'category_' + category.Id"
                          v-model="selectedCheckboxes"
                          @change="checkboxChangeHandler(subCategory.Id)"
                        />
                        <label
                          :for="'subcategory_' + subCategory.Id"
                          class="form-check-label"
                          >{{ subCategory.Name }}</label
                        >
                      </div>
                      <div
                        v-if="
                          selectedCheckboxes.find((x) => x == subCategory.Id)
                        "
                        style="display: inline-flex"
                      >
                        <div
                          v-for="childCategory in subCategory.ChildCategories"
                          :key="childCategory.Id"
                          :value="childCategory.Id"
                        >
                          <div
                            style="
                              display: inline-flex;
                              align-items: center;
                              padding-left: 3px;
                            "
                          >
                            <input
                              type="radio"
                              :id="'childCategory_' + childCategory.Id"
                              data-target="#tab-form-approve"
                              :value="'childCategory_' + childCategory.Id"
                              class="form-check-input"
                              :name="'subcategory_' + subCategory.Id"
                              :checked="
                                checkSelectedChildCategory(
                                  category.Id,
                                  subCategory.Id,
                                  childCategory.Id
                                ) &&
                                selectedCheckboxes.find(
                                  (x) => x == subCategory.Id
                                )
                              "
                              v-show="selectedCheckboxes"
                              @change="
                                selectedCategories(
                                  category.Id,
                                  subCategory.Id,
                                  childCategory.Id
                                )
                              "
                            />
                            <label
                              :for="'childCategory_' + childCategory.Id"
                              class="form-check-label"
                              >{{ childCategory.Name }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group invalid-feedback"
                      :style="[
                        requiredField.includes('category_' + category.Id)
                          ? { display: 'block' }
                          : '',
                      ]"
                    >
                      Bu alan boş geçilemez!
                    </div>
                  </div>
                </dl>
              </div>
              <div v-if="suggestedTeamLeaderName" class="form-group">
                <label for="suggestedTeamLeaderName"
                  ><strong>Önerilen Ekip Lideri</strong></label
                >
                <input
                  class="form-control short"
                  id="suggestedTeamLeaderName"
                  name="suggestedTeamLeaderName"
                  style="padding-left: 20px !important"
                  type="text"
                  v-model="suggestedTeamLeaderName"
                  readonly
                />
              </div>
              <div class="form-group decider-multiselect-wrapper">
                <label for="suggestedTeamLeaderName"
                  ><strong>Ekip Lideri</strong></label
                >
                <multiselect
                  v-model="teamLeader"
                  tag-placeholder="Add this as new tag"
                  placeholder="Ekip Lideri Seçiniz"
                  label="Name"
                  track-by="Id"
                  :options="optionTeamLeader"
                  :searchable="true"
                  style="padding: 0"
                  selectLabel="Seçmek için tıklayınız"
                  selectedLabel="Seçildi"
                  deselectLabel="Silmek için tıklayınız"
                >
                </multiselect>
              </div>
              <div
                id="teamLeaderError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('teamLeader')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş geçilemez!
              </div>
              <div class="form-group">
                <textarea
                  class="form-control short"
                  cols="20"
                  id="textSuggestionDeciderNote"
                  name="SuggestionDeciderNote"
                  placeholder="Fikir Değerlendirme Açıklaması..."
                  rows="2"
                  validationelement="1"
                  v-model="suggestionDeciderNote"
                ></textarea>
              </div>
              <div
                id="textSuggestionDeciderNoteError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('suggestionDeciderNote')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
                deneyiniz.
              </div>
              <div class="insider-form-button pb-2 pt-3">
                <button
                  type="button"
                  class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="removeValue"
                >
                  VAZGEÇ
                </button>
                <button
                  :disabled="isBtnDisabled"
                  type="button"
                  id="btnSendUpdate"
                  @click="sendUpdate(true)"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4 mr-3"
                >
                  KAYDET
                </button>
                <button
                  :disabled="isBtnDisabled"
                  type="button"
                  id="btnSendUpdate"
                  @click="sendUpdate(false)"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
                >
                  GÖNDER
                </button>
              </div>
            </form>
          </div>

          <div id="tab-form-return" v-if="evaluate == 'return'">
            <form
              action="/Admin/Update/5b677e5f-a0d9-eb11-bacb-000d3addce7f?isReturn=True&amp;status=Distributer"
              method="post"
            >
              <div class="form-group">
                <textarea
                  class="form-control"
                  cols="20"
                  id="ReasonForReturn"
                  name="ReasonForReturn"
                  placeholder="Geri gönderme nedenini giriniz"
                  required="required"
                  rows="2"
                  v-model="reasonForReturn"
                ></textarea>
              </div>
              <div
                class="form-group invalid-feedback"
                :style="[isReasonForReturn ? { display: 'block' } : '']"
              >
                Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
                deneyiniz.
              </div>
              <div class="insider-form-button pb-2 pt-3">
                <button
                  type="button"
                  class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearReturnValue"
                >
                  VAZGEÇ
                </button>
                <button
                  type="button"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
                  @click="openReturnModal"
                  :disabled="isBtnDisabled"
                >
                  GERİ GÖNDER
                </button>
              </div>
            </form>
          </div>

          <div v-if="evaluate == 'decline'" id="tab-form-decline" style="">
            <form
              action="/Admin/Update/c5dd0e00-a1d9-eb11-bacb-000d3addce7f?updateType=2&amp;status=Reject"
              method="post"
            >
              <div class="form-group icon-note">
                <select
                  class="form-control"
                  id="CancelReason"
                  name="CancelReason"
                  required="required"
                  v-model="cancelReason"
                >
                  <option
                    v-for="item in getCancelReasonsList"
                    :key="item.Id"
                    :value="item.Id"
                    :disabled="item.Id == ''"
                  >
                    {{ item.CancelReasonName }}
                  </option>
                </select>
              </div>
              <div
                id="cancelReasonError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('cancelReason')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş geçilemez!
              </div>
              <div class="form-group">
                <textarea
                  class="form-control short"
                  cols="20"
                  id="txtConfirmNote"
                  name="CancelDescription"
                  placeholder="Ret Açıklaması..."
                  required="required"
                  rows="2"
                  v-model="cancelDescription"
                ></textarea>
              </div>
              <div
                id="cancelDescriptionError"
                class="form-group invalid-feedback"
                :style="[
                  requiredField.includes('cancelDescription')
                    ? { display: 'block' }
                    : '',
                ]"
              >
                Bu alan boş bırakılamaz, karakter sayısını arttırarak tekrar
                deneyiniz.
              </div>
              <div class="insider-form-button pb-2 pt-3">
                <button
                  type="button"
                  class="btn-innovation-radius bg-orange Roboto-Bold py-2 px-4 mr-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearValue"
                >
                  VAZGEÇ
                </button>
                <button
                  type="button"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold py-2 px-4"
                  @click="declineSubmit"
                  :disabled="isBtnDisabled"
                >
                  GÖNDER
                </button>
              </div>
            </form>
          </div>
        </div>
      </dd>
    </dl>
    <transition name="fade">
      <div
        v-if="isReturnModal"
        id="Warning"
        class="modal fade show"
        style="height: 300px; display: block"
        role="dialog"
        data-backdrop="false"
      >
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <p>
                Geri gönderme işlemi, fikri bir önceki adıma geri gönderir ve
                farklı bir departmanın değerlendirmesine sunulur. Fikrin sizin
                departmanınızla ilgisi olmadığını düşünüyorsanız “Geri Gönder”
                seçeneğine basınız. Fikir detayına geri dönmek için “İptal”
                seçeneğine basınız.
              </p>
              <button
                type="button"
                class="btn btn-danger confirmclosed"
                style="margin-left: 27%"
                @click.stop="exitModal"
              >
                İptal
              </button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="sendReasonForReturn"
                :disabled="isBtnDisabled"
              >
                Geri Gönder
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import { suggestionService } from "../../../services";
import "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "Decider",
  data() {
    return {
      requiredField: [],
      isBtnDisabled: false,
      evaluate: "",
      suggestionDeciderNote: null,
      valueCurrentId: "",
      suggestionSubject: "",
      suggestionEvaluator: "",
      currenValuelist: [],
      cancelReason: "",
      cancelDescription: "",
      reasonForReturn: "",
      isReasonForReturn: false,
      teamLeader: "",
      optionTeamLeader: [],
      getCancelReasonsList: [],
      subDoinCategoryIds: [],
      isDoinUpdated: false,
      doinPointList: [],
      doinPointStructureList: [],
      selectedSubCategory: null,
      selectedCheckboxes: [], // Seçilen alt kategorileri saklamak için dizi
      maxSelections: 2, // Maksimum seçim sayısı
      totalPoints: 0, //toplam puan
      selectedSubCategories: [],
      isReturnModal: false,
      minLengthForText: 4,
      suggestedTeamLeaderName: "",
    };
  },
  components: {
    Multiselect,
  },
  props: {
    detailData: {
      type: Object,
    },
    selectedDoinList: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    gettersValueCurrents() {
      return this.$store.getters["suggestion/getValueCurrents"];
    },
    getUsers() {
      return this.$store.getters["user/getUsers"];
    },
    getCancelReasons() {
      return this.$store.getters["suggestion/getCancelReasons"];
    },
  },
  watch: {
    getUsers: {
      handler: function (val) {
        // Return the object that changed
        val.forEach((element) => {
          this.setUsers(element);
        });
      },
      deep: true,
    },
  },
  async created() {
    if (!this.getUsers) {
      await this.$store.dispatch("user/getUsers");
    } else {
      this.getUsers.forEach((element) => {
        this.setUsers(element);
      });
    }
    this.suggestionSubject = this.detailData.SuggestionSubjectId;
    this.valueCurrentId = this.detailData.ValueCurrentId;
    this.getValueCurrents();
    this.getDoinPointStructureList();
    await this.$store.dispatch("suggestion/getCancelReasons", {
      loginUserId: this.user.Data.UserId,
      statusId: this.detailData.SuggestionStatusId,
    });
    this.getCancelReasonsList = [
      { Id: "", CancelReasonName: "Nedeni Seçiniz" },
      ...this.getCancelReasons,
    ];
    this.subDoinCategoryIds = this.detailData.SubDoinCategoryIds ?? [];
    this.selectedDoinList.forEach((value) => {
      if (value.ChildCategoryId) {
        this.selectedCheckboxes.push(value.SubCategoryId);
      }
      this.selectedSubCategories.push({
        mainCategoryId: value.MainCategoryId,
        subCategoryId: value.SubCategoryId,
        childCategoryId: value.ChildCategoryId,
      });
    });
    if (this.detailData.TeamLeaderId) {
      this.teamLeader = {
        Name: this.detailData.TeamLeaderName,
        Id: this.detailData.TeamLeaderId,
      };
    } else if (this.detailData.SuggestedTeamLeaderId) {
      this.teamLeader = {
        Name: this.detailData.SuggestedTeamLeaderName,
        Id: this.detailData.SuggestedTeamLeaderId,
      };
    }
    this.suggestedTeamLeaderName = this.detailData.SuggestedTeamLeaderName;
    this.suggestionDeciderNote = this.detailData.SuggestionDeciderNote;
  },
  methods: {
    exitModal() {
      this.isReturnModal = false;
    },
    openReturnModal() {
      if (
        this.reasonForReturn &&
        this.reasonForReturn.trim().length > this.minLengthForText
      ) {
        this.isReturnModal = true;
      } else {
        this.isReasonForReturn = true;
      }
    },
    setUsers(element) {
      this.optionTeamLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
    },
    async getValueCurrents() {
      if (!this.gettersValueCurrents) {
        await this.$store.dispatch("suggestion/getValueCurrentsData");
      }
      this.currenValuelist = this.gettersValueCurrents;
    },
    removeValue() {
      this.suggestionDeciderNote = null;
      this.valueCurrentId = "";
      this.suggestionSubject = "";
      this.$emit("on-remove-value");
    },
    checkDoinCategoryValidations() {
      let isRequired = true;
      this.doinPointStructureList.forEach((category) => {
        if (
          this.selectedSubCategories.length == 0 ||
          !this.selectedSubCategories.find(
            (x) => x.mainCategoryId == category.Id
          )
        ) {
          isRequired = false;
        }
      });
      this.selectedCheckboxes.forEach((item) => {
        if (!this.selectedSubCategories.find((x) => x.subCategoryId == item)) {
          isRequired = false;
        }
      });
      return isRequired;
    },
    async sendUpdate(isDraft) {
      this.requiredField = [];
      if (
        this.checkDoinCategoryValidations() &&
        this.suggestionDeciderNote &&
        this.suggestionDeciderNote.trim().length > this.minLengthForText &&
        this.valueCurrentId != "" &&
        this.teamLeader != ""
      ) {
        this.isBtnDisabled = true;
        await this.$store.dispatch("loading/setIsLoading", true);
        await this.$emit("send-update", {
          suggestionDeciderNote: this.suggestionDeciderNote,
          valueCurrentId: this.valueCurrentId,
          suggestionSubject: this.suggestionSubject,
          teamLeaderId: this.teamLeader.Id,
          doinCategories: this.selectedSubCategories,
          isDraft: isDraft,
          callback: async () => {
            this.isBtnDisabled = false;
            await this.$store.dispatch("loading/setIsLoading", false);
          },
        });
      } else {
        if (
          !this.suggestionDeciderNote ||
          this.suggestionDeciderNote.trim().length <= this.minLengthForText
        )
          this.requiredField.push("suggestionDeciderNote");
        if (this.valueCurrentId == "")
          this.requiredField.push("valueCurrentId");
        if (this.teamLeader == "") this.requiredField.push("teamLeader");
        this.doinPointStructureList.forEach((category) => {
          if (
            this.selectedSubCategories.length == 0 ||
            !this.selectedSubCategories.find(
              (x) => x.mainCategoryId == category.Id
            )
          ) {
            this.requiredField.push("category_" + category.Id);
          }
        });
        this.selectedCheckboxes.forEach((item) => {
          if (
            !this.selectedSubCategories.find((x) => x.subCategoryId == item)
          ) {
            this.doinPointStructureList.forEach((c) => {
              if (c.SubCategories.find((s) => s.Id == item)) {
                this.requiredField.push("category_" + c.Id);
              }
            });
          }
        });
      }
    },
    clearValue() {
      this.cancelReason = "";
      this.cancelDescription = "";
      this.$emit("on-clear-value");
    },
    declineSubmit() {
      this.requiredField = [];
      if (
        this.cancelReason &&
        this.cancelDescription &&
        this.cancelDescription.trim().length > this.minLengthForText
      ) {
        this.isBtnDisabled = true;
        this.$emit("decline-submit", {
          cancelReason: this.cancelReason,
          cancelDescription: this.cancelDescription,
        });
        this.isBtnDisabled = false;
      } else {
        if (this.cancelReason == "") this.requiredField.push("cancelReason");
        if (
          !this.cancelDescription ||
          this.cancelDescription.trim().length <= this.minLengthForText
        )
          this.requiredField.push("cancelDescription");
      }
    },
    sendReasonForReturn() {
      if (
        this.reasonForReturn &&
        this.reasonForReturn.trim().length > this.minLengthForText
      ) {
        this.isBtnDisabled = true;
        this.$emit("send-reason-return", {
          reasonForReturn: this.reasonForReturn,
        });
        this.isBtnDisabled = false;
        this.isReasonForReturn = false;
      } else {
        this.isReasonForReturn = true;
      }
    },
    clearReturnValue() {
      this.reasonForReturn = null;
      this.$emit("on-clear-return-value");
    },
    async getDoinPointStructureList() {
      try {
        const res = await suggestionService.fetchGetDoinPointStructureList();
        this.doinPointStructureList = res.Data?.filter(
          (x) =>
            !(
              (x.StartDate &&
                new Date(x.StartDate) >
                  new Date(this.detailData.SuggestionDate)) ||
              (x.EndDate &&
                new Date(x.EndDate) < new Date(this.detailData.SuggestionDate))
            )
        );
      } catch (error) {
        //console.log(error);
      }
    },
    checkboxChangeHandler(subCategoryId) {
      if (this.selectedCheckboxes.length > this.maxSelections) {
        let uncheckedSubCategoryId = this.selectedCheckboxes.shift(); //ilk seçileni kaldırabilirsiniz
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== uncheckedSubCategoryId
        );
      }
      this.selectedSubCategories = this.selectedSubCategories.filter(
        (e) => e.subCategoryId !== subCategoryId
      );
    },
    selectedCategories(mainCategoryId, subCategoryId, childCategoryId) {
      let entity = {
        mainCategoryId: mainCategoryId,
        subCategoryId: subCategoryId,
        childCategoryId: childCategoryId,
      };
      if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        !childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.mainCategoryId !== mainCategoryId
        );
      } else if (
        this.selectedSubCategories.find(
          (e) => e.mainCategoryId === mainCategoryId
        ) &&
        childCategoryId
      ) {
        this.selectedSubCategories = this.selectedSubCategories.filter(
          (e) => e.subCategoryId !== subCategoryId
        );
      }
      this.selectedSubCategories.push(entity);
    },
    checkSelectedSubCategory(categoryId, subCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId && e.subCategoryId === subCategoryId
      );
    },
    checkSelectedChildCategory(categoryId, subCategoryId, childCategoryId) {
      return this.selectedSubCategories?.find(
        (e) =>
          e.mainCategoryId === categoryId &&
          e.subCategoryId === subCategoryId &&
          e.childCategoryId === childCategoryId
      );
    },
  },
};
</script>

<style>
.decider-multiselect-wrapper .multiselect .multiselect__tags > input {
  border: none !important;
}
</style>
